module.exports = __webpack_public_path__ + "img/menuDetails.b730fa98.png";